import script from "./TemplateRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateRow.vue?vue&type=script&setup=true&lang=js"

import "./TemplateRow.vue?vue&type=style&index=0&id=c502c30a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c502c30a"]])

export default __exports__